import { useRef, useState } from "react"
import calculatePrice from "./calculate"
import copy from "copy-to-clipboard"
import CodeTextarea from "./CodeTextarea"

const PriceCalculatorForm = () => {
  const [numberOfLines, setNumberOfLines] = useState(1)

  // refs
  const pricesToCalculateRef = useRef(null)
  const pricesChfRef = useRef(null)
  const pricesEurRef = useRef(null)

  // functions
  const calculateValues = async () => {
    const calculatedPrices = await calculatePrice(pricesToCalculateRef.current.value)
    if (calculatedPrices.error) {
      pricesEurRef.current.value = calculatedPrices.error
      pricesChfRef.current.value = calculatedPrices.error
    } else {
      pricesEurRef.current.value = calculatedPrices.eur
      pricesChfRef.current.value = calculatedPrices.chf
    }
  }
  const clickCopyAllHandler = (refToCopy) => {
    copy(refToCopy.current.value)
  }

  return (
    <>
      <div>
        <h3>Price Calculator</h3>
        <p>
          Calculate the sale price of a list of products based on their cost and a given margin.
        </p>
      </div>
      <form id="frmConverter" name="frmConverter">
        <div className="d-flex gap-1">
          <div>
            <h4>Buying price (€)</h4>
            <small>Taxes excluded</small>
            <CodeTextarea
              identifier="txtValuesToConvert"
              onChange={calculateValues}
              ref={pricesToCalculateRef}
              numberOfLines={numberOfLines}
              setNumberOfLines={setNumberOfLines}
            />
          </div>
          <div>
            <h4>Selling price (CHF)</h4>
            <small>Taxes included</small>
            <CodeTextarea
              identifier="txtConvertedValuesChf"
              ref={pricesChfRef}
              numberOfLines={numberOfLines}
              setNumberOfLines={setNumberOfLines}
              readOnly
            />
            <center>
              <button
                onClick={() => clickCopyAllHandler(pricesChfRef)}
                type="button"
                className="btn btn-primary"
                id="btnCopyAll"
                name="btnCopyAll"
              >
                Copy CHF Prices
              </button>
            </center>
          </div>
          <div>
            <h4>Selling price (€)</h4>
            <small>Taxes included</small>

            <CodeTextarea
              identifier="txtConvertedValuesEur"
              ref={pricesEurRef}
              numberOfLines={numberOfLines}
              setNumberOfLines={setNumberOfLines}
              readOnly
            />
            <center>
              <button
                onClick={() => clickCopyAllHandler(pricesEurRef)}
                type="button"
                className="btn btn-primary"
                id="btnCopyAll"
                name="btnCopyAll"
              >
                Copy € Prices
              </button>
            </center>
          </div>
        </div>
      </form>
    </>
  )
}

export default PriceCalculatorForm
